import {
  TransactionServiceFormRule,
  TransactionServiceFormSchema,
} from "@factory/form/form.rule";
import "./form-transaction-service-wrapper.scss";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { transactionServiceFormDefault } from "@factory/form/form.default";
import { zodResolver } from "@hookform/resolvers/zod";
import { forwardRef, useImperativeHandle, useEffect } from "react";
import FormTransactionService from "../form-transaction-service/form-transaction-service";
import { LabelValue } from "@shared/models/label-value.interface";

export interface FormTransactionServiceWrapperProps {
  member?: LabelValue;
  onSubmit: (data: TransactionServiceFormSchema) => void;
  hideAdvanceBooking?: boolean;
  defaultValues?: Partial<TransactionServiceFormSchema>;
  onChange?: (data: TransactionServiceFormSchema) => void;
}
export interface FormTransactionServiceWrapperRef {
  triggerSubmit: () => Promise<boolean>;
}

export function FormTransactionServiceWrapper(
  props: FormTransactionServiceWrapperProps,
  ref: React.Ref<FormTransactionServiceWrapperRef>
) {
  const formMethod = useForm<TransactionServiceFormSchema>({
    defaultValues: {
      ...transactionServiceFormDefault,
      ...props.defaultValues,
    },
    resolver: zodResolver(TransactionServiceFormRule),
  });
  const { handleSubmit, watch } = formMethod;

  useImperativeHandle(ref, () => ({
    triggerSubmit: async () => {
      const isValid = await formMethod.trigger();
      if (isValid) {
        await handleSubmit(submitHandler)();
      }
      return isValid;
    },
  }));

  const submitHandler: SubmitHandler<TransactionServiceFormSchema> = (data) => {
    props.onSubmit(data);
  };

  const values = watch();
  const onChange = props.onChange;

  useEffect(() => {
    if (onChange) {
      onChange(values);
    }
  }, [values, onChange]);

  return (
    <div
      id="FormTransactionServiceWrapper"
      className="form-transaction-service-wrapper"
    >
      <FormProvider {...formMethod}>
        <FormTransactionService
          member={props.member}
          hideAdvanceBooking={props.hideAdvanceBooking}
        />
      </FormProvider>
    </div>
  );
}

export default forwardRef(FormTransactionServiceWrapper);
